export const scrollY = () => window.scrollY || window.pageYOffset;
